<template>
    <div class="min-h-screen bg-gray-50">
        <!-- Header mejorado -->
        <div class="bg-white shadow-sm border-b sticky top-0 z-20">
            <div class="px-4 py-4">
                <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <div class="flex items-center gap-4">
                        <div class="p-3 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-xl shadow-lg">
                            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                            </svg>
                        </div>
                        <div>
                            <h1 class="text-3xl font-bold text-gray-900">Empresas</h1>
                            <p class="text-sm text-gray-500 mt-1">Gestiona las empresas del sistema</p>
                        </div>
                    </div>
                    
                    <div class="flex items-center gap-3">
                        <button
                            v-if="selectedEmpresas.length > 0"
                            @click="deleteSelectedModal"
                            class="inline-flex items-center justify-center gap-2 px-5 py-3 bg-red-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:bg-red-600 transition-all duration-200"
                        >
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                            </svg>
                            Eliminar ({{ selectedEmpresas.length }})
                        </button>
                        <router-link
                            :to="{ path: '/owner/formEmpresasAdmin' }"
                            class="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-emerald-600 hover:to-teal-600 transition-all duration-200 transform hover:-translate-y-0.5"
                        >
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                            </svg>
                            Nueva Empresa
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="px-4 mt-4">
            <!-- Estadísticas Cards -->
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                <div class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-4 border-l-4 border-emerald-500">
                    <div class="flex items-center justify-between">
                        <div>
                            <p class="text-xs font-medium text-gray-600 uppercase">Total Empresas</p>
                            <p class="text-2xl font-bold text-gray-900 mt-1">{{ empresas.length }}</p>
                        </div>
                        <div class="p-3 bg-emerald-100 rounded-full">
                            <svg class="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-4 border-l-4 border-blue-500">
                    <div class="flex items-center justify-between">
                        <div>
                            <p class="text-xs font-medium text-gray-600 uppercase">Activas</p>
                            <p class="text-2xl font-bold text-gray-900 mt-1">{{ empresasActivas }}</p>
                        </div>
                        <div class="p-3 bg-blue-100 rounded-full">
                            <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-4 border-l-4 border-purple-500">
                    <div class="flex items-center justify-between">
                        <div>
                            <p class="text-xs font-medium text-gray-600 uppercase">Resultados</p>
                            <p class="text-2xl font-bold text-gray-900 mt-1">{{ filtered.length }}</p>
                        </div>
                        <div class="p-3 bg-purple-100 rounded-full">
                            <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-4 border-l-4 border-orange-500">
                    <div class="flex items-center justify-between">
                        <div>
                            <p class="text-xs font-medium text-gray-600 uppercase">Seleccionadas</p>
                            <p class="text-2xl font-bold text-gray-900 mt-1">{{ selectedEmpresas.length }}</p>
                        </div>
                        <div class="p-3 bg-orange-100 rounded-full">
                            <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Barra de búsqueda y filtros mejorada -->
            <div class="bg-white rounded-lg shadow-sm p-4 mb-4">
                <div class="flex flex-col gap-4">
                    <!-- Primera fila: Búsqueda y vista -->
                    <div class="flex flex-col lg:flex-row gap-4 items-center justify-between">
                        <div class="relative flex-1 w-full lg:max-w-md">
                            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                                </svg>
                            </div>
                            <input
                                v-model="search"
                                type="search"
                                placeholder="Buscar por nombre o ID..."
                                class="block w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition duration-150 ease-in-out"
                            />
                        </div>

                        <div class="flex items-center gap-4">
                            <label class="inline-flex items-center cursor-pointer">
                                <input type="checkbox" v-model="showAll" class="sr-only peer" />
                                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500"></div>
                                <span class="ms-3 text-sm font-medium text-gray-700">Mostrar todos</span>
                            </label>

                            <label class="inline-flex items-center cursor-pointer">
                                <input type="checkbox" :checked="selectAll" @change="toggleSelectAll" class="w-4 h-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500" />
                                <span class="ms-2 text-sm font-medium text-gray-700">Seleccionar todos</span>
                            </label>

                            <select v-model="viewMode" class="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm">
                                <option value="grid">Vista Tarjetas</option>
                                <option value="table">Vista Tabla</option>
                            </select>
                        </div>
                    </div>

                    <!-- Segunda fila: Filtros adicionales -->
                    <div class="flex flex-col sm:flex-row gap-3">
                        <div class="flex-1">
                            <label class="block text-xs font-medium text-gray-700 mb-1">Ordenar por</label>
                            <select v-model="sortBy" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500">
                                <option value="">Sin ordenar</option>
                                <option value="nombre">Nombre (A-Z)</option>
                                <option value="usuarios">Cantidad de usuarios</option>
                                <option value="ultimaConexion">Última conexión</option>
                            </select>
                        </div>
                        <div class="flex-1">
                            <label class="block text-xs font-medium text-gray-700 mb-1">Usuarios</label>
                            <select v-model="filterUsuarios" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500">
                                <option value="all">Todos</option>
                                <option value="con">Con usuarios</option>
                                <option value="sin">Sin usuarios</option>
                                <option value="1-5">1-5 usuarios</option>
                                <option value="6-10">6-10 usuarios</option>
                                <option value="11+">11+ usuarios</option>
                            </select>
                        </div>
                        <div class="flex-1">
                            <label class="block text-xs font-medium text-gray-700 mb-1">Última conexión</label>
                            <select v-model="filterConexion" class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500">
                                <option value="all">Todas</option>
                                <option value="hoy">Hoy</option>
                                <option value="semana">Última semana</option>
                                <option value="mes">Último mes</option>
                                <option value="nunca">Sin conexiones</option>
                            </select>
                        </div>
                        <div class="flex items-end">
                            <button 
                                @click="resetFilters"
                                class="px-4 py-2 text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors whitespace-nowrap"
                            >
                                Limpiar filtros
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vista de Tarjetas -->
            <div v-if="viewMode === 'grid'" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-4">
                <div
                    v-for="empresa in paginatedEmpresas"
                    :key="empresa.id"
                    class="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden border-2"
                    :class="{ 
                        'opacity-60': !empresa.isActive,
                        'border-emerald-400 ring-2 ring-emerald-200': isSelected(empresa.id),
                        'border-gray-200': !isSelected(empresa.id)
                    }"
                >
                    <div class="bg-gradient-to-r from-emerald-500 to-teal-500 p-3 text-white">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    :checked="isSelected(empresa.id)"
                                    @change="toggleSelection(empresa.id)"
                                    class="w-5 h-5 text-emerald-600 bg-white border-white rounded focus:ring-emerald-500 focus:ring-2 cursor-pointer"
                                    @click.stop
                                />
                                <div class="p-1.5 bg-white/20 rounded backdrop-blur-sm">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                    </svg>
                                </div>
                                <span class="text-xs font-semibold">ID: {{ empresa.id }}</span>
                            </div>
                            <button
                                @click="toggleEmpresaStatus(empresa)"
                                :class="empresa.isActive ? 'bg-green-500/30' : 'bg-red-500/30'"
                                class="px-2 py-1 backdrop-blur-sm rounded-full text-xs font-semibold hover:bg-white/40 transition-colors"
                                :title="empresa.isActive ? 'Desactivar empresa' : 'Activar empresa'"
                            >
                                {{ empresa.isActive ? 'Activa' : 'Inactiva' }}
                            </button>
                        </div>
                    </div>

                    <div class="p-4">
                        <h3 class="text-lg font-bold text-gray-900 mb-3 truncate" :title="empresa.name">
                            {{ empresa.name }}
                        </h3>

                        <div class="space-y-2 mb-4">
                            <div class="flex items-center justify-between text-sm">
                                <div class="flex items-center gap-2 text-gray-600">
                                    <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                                    </svg>
                                    <span>Usuarios</span>
                                </div>
                                <button
                                    @click="toggleUsuariosList(empresa.id)"
                                    class="flex items-center gap-1 font-semibold text-emerald-600 hover:text-emerald-700"
                                >
                                    <span>{{ getUsuariosCount(empresa.id) }}</span>
                                    <svg 
                                        class="w-4 h-4 transition-transform"
                                        :class="{ 'rotate-180': showUsuarios[empresa.id] }"
                                        fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                    >
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                                    </svg>
                                </button>
                            </div>

                            <div class="flex items-center justify-between text-xs text-gray-500">
                                <div class="flex items-center gap-2">
                                    <svg class="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                    </svg>
                                    <span>Última conexión</span>
                                </div>
                                <span class="font-medium text-gray-700">
                                    {{ getLastLoginByTenant(empresa.id) ? new Date(getLastLoginByTenant(empresa.id)).toLocaleDateString('es-ES') : 'Nunca' }}
                                </span>
                            </div>

                            <!-- Lista de usuarios expandible -->
                            <div v-if="showUsuarios[empresa.id]" class="pl-6 space-y-1 mt-2 max-h-32 overflow-y-auto text-xs">
                                <div 
                                    v-for="usuario in getUsuariosByTenant(empresa.id)" 
                                    :key="usuario.id"
                                    class="flex items-center justify-between py-1 px-2 bg-gray-50 rounded border border-gray-100"
                                >
                                    <span class="text-gray-800 font-medium truncate flex-1">
                                        {{ [usuario.nombre, usuario.apellido].filter(Boolean).join(' ') || usuario.email || 'Usuario sin nombre' }}
                                    </span>
                                    <span :class="usuario.isActive ? 'text-green-600' : 'text-red-600'" class="font-semibold ml-2 flex-shrink-0">
                                        {{ usuario.isActive ? '✓' : '✗' }}
                                    </span>
                                </div>
                                <div v-if="getUsuariosByTenant(empresa.id).length === 0" class="text-gray-400 italic py-1">
                                    Sin usuarios
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-3 gap-1.5">
                            <button
                                @click="editarEmpresa(empresa)"
                                class="inline-flex items-center justify-center gap-1 px-2 py-2 bg-emerald-50 text-emerald-700 text-xs font-medium rounded hover:bg-emerald-100 transition-colors"
                                title="Editar"
                            >
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                                </svg>
                                <span class="hidden sm:inline">Editar</span>
                            </button>
                            <button
                                @click="toggleEmpresaStatus(empresa)"
                                :class="empresa.isActive ? 'bg-yellow-50 text-yellow-700 hover:bg-yellow-100' : 'bg-green-50 text-green-700 hover:bg-green-100'"
                                class="inline-flex items-center justify-center gap-1 px-2 py-2 text-xs font-medium rounded transition-colors"
                                :title="empresa.isActive ? 'Desactivar' : 'Activar'"
                            >
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path v-if="empresa.isActive" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
                                    <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                                <span class="hidden sm:inline">{{ empresa.isActive ? 'Off' : 'On' }}</span>
                            </button>
                            <button
                                @click="deleteModal(empresa.id)"
                                class="inline-flex items-center justify-center gap-1 px-2 py-2 bg-red-50 text-red-600 text-xs font-medium rounded hover:bg-red-100 transition-colors"
                                title="Eliminar"
                            >
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                </svg>
                                <span class="hidden sm:inline">Del</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Empty state -->
                <div v-if="paginatedEmpresas.length === 0" class="col-span-full">
                    <div class="text-center py-16 px-4">
                        <div class="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-4">
                            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                            </svg>
                        </div>
                        <h3 class="text-lg font-semibold text-gray-900 mb-2">No se encontraron empresas</h3>
                        <p class="text-gray-500 mb-6">Intenta ajustar los filtros de búsqueda</p>
                        <button @click="search = ''" class="px-4 py-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600">
                            Limpiar búsqueda
                        </button>
                    </div>
                </div>
            </div>

            <!-- Vista de Tabla -->
            <div v-if="viewMode === 'table'" class="bg-white rounded-xl shadow-md overflow-hidden mb-6">
                <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gradient-to-r from-gray-50 to-gray-100">
                            <tr>
                                <th class="px-6 py-4 text-left">
                                    <input
                                        type="checkbox"
                                        :checked="selectAll"
                                        @change="toggleSelectAll"
                                        class="w-4 h-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500 cursor-pointer"
                                    />
                                </th>
                                <th class="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">ID</th>
                                <th class="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Nombre</th>
                                <th class="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Usuarios</th>
                                <th class="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Estado</th>
                                <th class="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">Acciones</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="empresa in paginatedEmpresas" :key="empresa.id" 
                                class="transition-colors duration-150"
                                :class="{ 'bg-emerald-50': isSelected(empresa.id), 'hover:bg-gray-50': !isSelected(empresa.id) }"
                            >
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <input
                                        type="checkbox"
                                        :checked="isSelected(empresa.id)"
                                        @change="toggleSelection(empresa.id)"
                                        class="w-4 h-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500 cursor-pointer"
                                    />
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-800">
                                        #{{ empresa.id }}
                                    </span>
                                </td>
                                <td class="px-6 py-4">
                                    <div class="flex items-center">
                                        <div class="flex-shrink-0 h-10 w-10 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-lg flex items-center justify-center">
                                            <span class="text-white font-bold text-sm">{{ empresa.name.charAt(0).toUpperCase() }}</span>
                                        </div>
                                        <div class="ml-4">
                                            <div class="text-sm font-semibold text-gray-900">{{ empresa.name }}</div>
                                            <div class="text-xs text-gray-500">Empresa activa</div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="flex items-center gap-2">
                                        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                                        </svg>
                                        <span class="text-sm text-gray-900 font-medium">{{ getUsuariosCount(empresa.id) }}</span>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                        <span class="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                        Activa
                                    </span>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <div class="flex items-center justify-end gap-2">
                                        <button
                                            @click="editarEmpresa(empresa)"
                                            class="inline-flex items-center gap-1 px-3 py-2 bg-emerald-50 text-emerald-700 rounded-lg hover:bg-emerald-100 transition-colors"
                                            title="Editar empresa"
                                        >
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                                            </svg>
                                            Editar
                                        </button>
                                        <button
                                            @click="deleteModal(empresa.id)"
                                            class="inline-flex items-center gap-1 px-3 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
                                            title="Eliminar empresa"
                                        >
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                            </svg>
                                            Eliminar
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="paginatedEmpresas.length === 0">
                                <td colspan="5" class="px-6 py-16 text-center">
                                    <div class="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                                        <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                        </svg>
                                    </div>
                                    <p class="text-gray-500 text-sm">No se encontraron empresas</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Paginación mejorada -->
            <div v-if="paginatedEmpresas.length > 0" class="bg-white rounded-lg shadow-sm px-4 py-3">
                <div class="flex flex-col sm:flex-row items-center justify-between gap-3">
                    <div class="text-xs text-gray-600">
                        Mostrando <span class="font-semibold text-gray-900">{{ startItem }}</span> - 
                        <span class="font-semibold text-gray-900">{{ endItem }}</span> de 
                        <span class="font-semibold text-gray-900">{{ filtered.length }}</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <button
                            @click="prevPage"
                            :disabled="page === 1"
                            class="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                            </svg>
                            Anterior
                        </button>
                        <span class="px-3 py-1.5 text-xs font-medium text-gray-700">
                            {{ page }} / {{ totalPages }}
                        </span>
                        <button
                            @click="nextPage"
                            :disabled="page === totalPages"
                            class="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            Siguiente
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Modal message="empresa" @confirm="deleteEmpresa" ref="modalComponent" />
    </div>
</template>


<script>
import { ref, reactive, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import empresaService from "../../../composables/api/empresaService";
import authService from "../../../composables/api/authService";
import Modal from "../../modalConfirmar/ModalConfirmar.vue";

export default {
    components: { Modal },
    name: "empresas",
    setup() {
        const empresas = ref([]);
        const usuarios = ref([]);
        const router = useRouter();
        const modalComponent = ref(null);
        const modal = ref(null);

        const search = ref("");
        const showAll = ref(false);
        const page = ref(1);
        const perPage = ref(12); // 12 tarjetas por página en vista grid
        const viewMode = ref('grid'); // 'grid' o 'table'
        const showUsuarios = reactive({}); // Control de expansión de usuarios por empresa
        
        // Nuevos filtros
        const sortBy = ref('');
        const filterUsuarios = ref('all');
        const filterConexion = ref('all');
        
        // Selección múltiple
        const selectedEmpresas = ref([]);

        const fetchEmpresas = async () => {
            try {
                const empresasData = await empresaService.getAllEmpresa();
                // Agregar propiedad isActive si no existe (por defecto true)
                empresas.value = empresasData.map(e => ({
                    ...e,
                    isActive: e.isActive !== undefined ? e.isActive : true
                }));
            } catch (error) {
                console.error(error);
            }
        };

        const fetchUsuarios = async () => {
            try {
                usuarios.value = await authService.getUsers();
            } catch (error) {
                console.error('Error al cargar usuarios:', error);
            }
        };

        const getUsuariosCount = (tenantId) => {
            return usuarios.value.filter(u => u.tenantId === tenantId).length;
        };

        const getUsuariosByTenant = (tenantId) => {
            return usuarios.value.filter(u => u.tenantId === tenantId);
        };

        const getLastLoginByTenant = (tenantId) => {
            const tenantUsers = usuarios.value.filter(u => u.tenantId === tenantId);
            if (tenantUsers.length === 0) return null;
            
            const lastLogins = tenantUsers
                .map(u => u.lastLoginTime ? new Date(u.lastLoginTime).getTime() : 0)
                .filter(t => t > 0);
            
            return lastLogins.length > 0 ? new Date(Math.max(...lastLogins)) : null;
        };

        const toggleUsuariosList = (empresaId) => {
            showUsuarios[empresaId] = !showUsuarios[empresaId];
        };

        const resetFilters = () => {
            search.value = '';
            sortBy.value = '';
            filterUsuarios.value = 'all';
            filterConexion.value = 'all';
            showAll.value = false;
            page.value = 1;
        };

        const isSelected = (empresaId) => {
            return selectedEmpresas.value.includes(empresaId);
        };

        const toggleSelection = (empresaId) => {
            const index = selectedEmpresas.value.indexOf(empresaId);
            if (index > -1) {
                selectedEmpresas.value.splice(index, 1);
            } else {
                selectedEmpresas.value.push(empresaId);
            }
        };

        const selectAll = computed(() => {
            const paginated = paginatedEmpresas.value;
            return paginated && paginated.length > 0 && 
                   paginated.every(e => selectedEmpresas.value.includes(e.id));
        });

        const toggleSelectAll = () => {
            const paginated = paginatedEmpresas.value;
            if (!paginated) return;
            
            if (selectAll.value) {
                // Deseleccionar todas las de la página actual
                paginated.forEach(e => {
                    const index = selectedEmpresas.value.indexOf(e.id);
                    if (index > -1) {
                        selectedEmpresas.value.splice(index, 1);
                    }
                });
            } else {
                // Seleccionar todas las de la página actual
                paginated.forEach(e => {
                    if (!selectedEmpresas.value.includes(e.id)) {
                        selectedEmpresas.value.push(e.id);
                    }
                });
            }
        };

        const deleteSelectedModal = () => {
            if (selectedEmpresas.value.length === 0) return;
            
            const confirmed = confirm(
                `¿Está seguro de eliminar ${selectedEmpresas.value.length} empresa(s)?\n\n` +
                `Esta acción no se puede deshacer y eliminará todas las empresas seleccionadas.`
            );
            
            if (confirmed) {
                deleteMultipleEmpresas();
            }
        };

        const deleteMultipleEmpresas = async () => {
            const empresasToDelete = [...selectedEmpresas.value];
            let successCount = 0;
            let errorCount = 0;
            const errors = [];

            for (const empresaId of empresasToDelete) {
                try {
                    await empresaService.removeEmpresa(empresaId);
                    successCount++;
                    // Remover de la lista de seleccionados
                    const index = selectedEmpresas.value.indexOf(empresaId);
                    if (index > -1) {
                        selectedEmpresas.value.splice(index, 1);
                    }
                } catch (error) {
                    errorCount++;
                    const empresa = empresas.value.find(e => e.id === empresaId);
                    errors.push(`${empresa?.name || `ID ${empresaId}`}: ${error.message || 'Error desconocido'}`);
                    console.error(`Error al eliminar empresa ${empresaId}:`, error);
                }
            }

            // Refrescar datos
            await fetchEmpresas();
            await fetchUsuarios();

            // Mostrar resultado
            let message = '';
            if (successCount > 0) {
                message += `✓ ${successCount} empresa(s) eliminada(s) exitosamente.\n`;
            }
            if (errorCount > 0) {
                message += `✗ ${errorCount} empresa(s) no se pudieron eliminar:\n${errors.join('\n')}`;
            }

            alert(message);
        };

        const toggleEmpresaStatus = async (empresa) => {
            try {
                const newStatus = !empresa.isActive;
                
                // Actualizar estado de la empresa
                await empresaService.toggleEmpresaStatus(empresa.id, newStatus);
                empresa.isActive = newStatus;

                // Si se desactiva la empresa, desactivar todos sus usuarios
                if (!newStatus) {
                    const usuariosEmpresa = getUsuariosByTenant(empresa.id);
                    for (const usuario of usuariosEmpresa) {
                        if (usuario.isActive) {
                            try {
                                await authService.toggleUserStatus(usuario.id, false);
                                usuario.isActive = false;
                            } catch (error) {
                                console.error(`Error al desactivar usuario ${usuario.id}:`, error);
                            }
                        }
                    }
                }
                
                // Refrescar datos
                await fetchUsuarios();
            } catch (error) {
                console.error('Error al cambiar estado de empresa:', error);
                // Si el backend no soporta esta función, solo cambiar localmente
                empresa.isActive = !empresa.isActive;
            }
        };

        const getDaysAgo = (date) => {
            if (!date) return 0;
            const now = new Date();
            const created = new Date(date);
            const diffTime = Math.abs(now - created);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays;
        };

        const editarEmpresa = (Tenant) => {
            router.push({ path: "/owner/formEmpresasAdmin", query: { isAdmin: false, id: Tenant.id } });
        };

        const deleteEmpresa = async (TenantId) => {
            try {
                await empresaService.removeEmpresa(TenantId);
                await fetchEmpresas();
                await fetchUsuarios();
                alert('Empresa eliminada exitosamente');
            } catch (error) {
                console.error('Error al eliminar empresa:', error);
                alert(error.message || 'No se pudo eliminar la empresa. Verifique que no tenga datos asociados.');
            }
        };

        const deleteModal = async (TenantId) => {
            modal.value = await modalComponent.value.getModal(TenantId);
        };

        onMounted(async () => {
            await fetchEmpresas();
            await fetchUsuarios();
        });

        const filtered = computed(() => {
            let list = [...empresas.value];
            
            // Filtro de búsqueda
            const q = search.value && search.value.toString().toLowerCase();
            if (q) {
                list = list.filter((e) => {
                    return (e.name && e.name.toString().toLowerCase().includes(q)) || (e.id && e.id.toString().includes(q));
                });
            }

            // Filtro por cantidad de usuarios
            if (filterUsuarios.value !== 'all') {
                list = list.filter(e => {
                    const count = getUsuariosCount(e.id);
                    switch (filterUsuarios.value) {
                        case 'con': return count > 0;
                        case 'sin': return count === 0;
                        case '1-5': return count >= 1 && count <= 5;
                        case '6-10': return count >= 6 && count <= 10;
                        case '11+': return count >= 11;
                        default: return true;
                    }
                });
            }

            // Filtro por última conexión
            if (filterConexion.value !== 'all') {
                const now = new Date();
                list = list.filter(e => {
                    const lastLogin = getLastLoginByTenant(e.id);
                    if (!lastLogin && filterConexion.value === 'nunca') return true;
                    if (!lastLogin) return false;
                    
                    const diffMs = now - lastLogin;
                    const diffDays = diffMs / (1000 * 60 * 60 * 24);
                    
                    switch (filterConexion.value) {
                        case 'hoy': return diffDays < 1;
                        case 'semana': return diffDays <= 7;
                        case 'mes': return diffDays <= 30;
                        case 'nunca': return false;
                        default: return true;
                    }
                });
            }

            // Ordenamiento
            if (sortBy.value) {
                list.sort((a, b) => {
                    switch (sortBy.value) {
                        case 'nombre':
                            return (a.name || '').localeCompare(b.name || '');
                        case 'usuarios':
                            return getUsuariosCount(b.id) - getUsuariosCount(a.id);
                        case 'ultimaConexion':
                            const lastA = getLastLoginByTenant(a.id);
                            const lastB = getLastLoginByTenant(b.id);
                            if (!lastA && !lastB) return 0;
                            if (!lastA) return 1;
                            if (!lastB) return -1;
                            return lastB - lastA;
                        default:
                            return 0;
                    }
                });
            }

            return list;
        });

        const empresasActivas = computed(() => {
            return empresas.value.filter(e => e.isActive).length;
        });

        const totalPages = computed(() => {
            if (showAll.value) return 1;
            const itemsPerPage = viewMode.value === 'grid' ? 12 : 10;
            return Math.max(1, Math.ceil(filtered.value.length / itemsPerPage));
        });

        const paginatedEmpresas = computed(() => {
            if (showAll.value) return filtered.value;
            const itemsPerPage = viewMode.value === 'grid' ? 12 : 10;
            const start = (page.value - 1) * itemsPerPage;
            return filtered.value.slice(start, start + itemsPerPage);
        });

        const startItem = computed(() => {
            if (filtered.value.length === 0) return 0;
            const itemsPerPage = viewMode.value === 'grid' ? 12 : 10;
            return showAll.value ? 1 : (page.value - 1) * itemsPerPage + 1;
        });

        const endItem = computed(() => {
            if (filtered.value.length === 0) return 0;
            const itemsPerPage = viewMode.value === 'grid' ? 12 : 10;
            return showAll.value ? filtered.value.length : Math.min(filtered.value.length, page.value * itemsPerPage);
        });

        function nextPage() {
            if (page.value < totalPages.value) page.value += 1;
        }
        function prevPage() {
            if (page.value > 1) page.value -= 1;
        }

        return {
            empresas,
            usuarios,
            editarEmpresa,
            deleteEmpresa,
            modalComponent,
            modal,
            deleteModal,
            search,
            showAll,
            page,
            perPage,
            viewMode,
            filtered,
            paginatedEmpresas,
            totalPages,
            nextPage,
            prevPage,
            startItem,
            endItem,
            fetchEmpresas,
            getUsuariosCount,
            getUsuariosByTenant,
            getLastLoginByTenant,
            toggleUsuariosList,
            toggleEmpresaStatus,
            showUsuarios,
            getDaysAgo,
            empresasActivas,
            sortBy,
            filterUsuarios,
            filterConexion,
            resetFilters,
            selectedEmpresas,
            isSelected,
            toggleSelection,
            selectAll,
            toggleSelectAll,
            deleteSelectedModal,
            deleteMultipleEmpresas,
        };
    },
};
</script>

<style scoped>
/* Animaciones suaves */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    animation: fadeIn 0.3s ease-out;
}

/* Scrollbar personalizado */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: #10b981;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #059669;
}

/* Transiciones suaves para hover */
button, a {
    transition: all 0.2s ease-in-out;
}

/* Efecto de elevación en tarjetas */
.hover\:-translate-y-1:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
</style>
